import { useQuery, type QueryObserverOptions } from '@tanstack/react-query'
import { PricingService } from '../../lib/api/pricing.services'
import type { GetPricingRegionResponse } from '../../lib/api/types/pricing.interfaces'

export const usePricingRegion = (
	options?: Partial<QueryObserverOptions<GetPricingRegionResponse>>,
) =>
	useQuery<GetPricingRegionResponse>({
		queryKey: ['pricingRegion'],
		queryFn: () => PricingService.getPricingRegion(),
		...options,
	})
